module.exports = __webpack_public_path__ + "img/chinesecompany180.711b526a.png";